import { useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext";

export function Logo() {
    const app = useContext(AppContext);
    var logover = document.getElementById("LogoVersion").getAttribute('data-ver');
    return (
        <Link className="navbar-brand p-0 me-0 me-lg-2" to={app.userLoggedIn ? "/home" : "/"} aria-label={app.firmName}>
            <img src={`/app/StyleBundle/logofirm/?v=${logover}`} className="logo" style={{ maxHeight: 50 }} alt="image not found" />
        </Link>
    );
}